import { useState, useEffect, useRef } from "react";

interface AnimatedCounterProps {
    value: number;
    format?: (v: number) => string;
    duration?: number;
}

export function AnimatedCounter({
    value,
    format = (v: number) => v.toString(),
    duration = 1000,
}: AnimatedCounterProps) {
    const [displayValue, setDisplayValue] = useState(value);
    const prevValueRef = useRef(value);

    useEffect(() => {
        const startTime = Date.now();
        const startValue = prevValueRef.current;
        const endValue = value;

        if (startValue === endValue) {
            return;
        }

        const updateValue = () => {
            const now = Date.now();
            const progress = Math.min((now - startTime) / duration, 1);
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            const currentValue = startValue + (endValue - startValue) * easeOutQuart;

            setDisplayValue(currentValue);

            if (progress < 1) {
                requestAnimationFrame(updateValue);
            } else {
                prevValueRef.current = endValue;
            }
        };

        requestAnimationFrame(updateValue);
    }, [value, duration]);

    return <>{format(displayValue)}</>;
}
